import type { TourDef } from '../types';

/** For everyone: the menu, kudos, events, learning and points, from the dashboard. */
const member: TourDef = {
  id: 'member',
  version: 1,
  route: '/dashboard',
  roles: ['everyone'],
  steps: [
    // On a phone the menu is closed, so the step points at the button that opens it.
    { target: ['[data-tour="app-nav"]', '[data-tour="app-menu-toggle"]'], key: 'menu', padding: 0 },
    { target: '[data-tour="nav-kudos"]', key: 'kudos' },
    // With the menu closed (a phone), the dashboard's own events and learning cards stand in.
    { target: ['[data-tour="nav-events"]', '[data-tour="dashboard-suggested"]'], key: 'events' },
    { target: ['[data-tour="nav-learning"]', '[data-tour="dashboard-progress"]'], key: 'learning' },
    { target: '[data-tour="dashboard-points"]', key: 'points' },
  ],
};

export default member;
